import axios from 'axios'
import router from '../router'
import store from '../store'

const client = axios.create({
  baseURL: '/api',
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json'
  }
})

client.interceptors.request.use(config => {
  if (store.state.token) {
    config.headers.Authorization = `Bearer ${store.state.token}`
  }
  return config
})

client.interceptors.response.use(
  response => response,
  error => {
    if (error.response && error.response.status === 401 && router.currentRoute.name !== 'login') {
      store.commit('clearSession')
      router.replace({ name: 'login' })
    }
    return Promise.reject(error)
  }
)

export default client

